import React from "react";
import { thisIsTheBrowser } from "@utils";

const PaypalCreditCartTag = React.memo(() => (
  <>
    {thisIsTheBrowser && (
      <div className="pay-pal-credit-modal">
        <script
          type="text/javascript"
          data-pp-payerid="LYV8AMMJJT4FQ"
          data-pp-placementtype="765x60"
        >
          {(function (d, t) {
            "use strict";
            var s = d.getElementsByTagName(t)[0],
              n = d.createElement(t);
            n.src = "//paypal.adtag.where.com/merchant.js";
            s.parentNode.insertBefore(n, s);
          })(document, "script")}
        </script>
      </div>
    )}
  </>
));

export default PaypalCreditCartTag;
